import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import React from "react";

import css from "./stored_as_cell.module.scss";

type StoredAsCellProps = {
  name: string;
  isOrderable: boolean;
};

export const StoredAsCell = ({ name, isOrderable }: StoredAsCellProps): JSX.Element => (
  <div className={css.root}>
    <Typography variant="bodyBold" tag="span">
      {name}
    </Typography>
    <div className={css.iconContainer}>
      {isOrderable && <Icon name="hierarchical" fill="var(--paletteBlue0)" className={css.icon} />}
    </div>
  </div>
);
